import { useEffect, useState, type FormEvent } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'
import { PayMethodPicker, payTotal } from '../components/PayMethodPicker'
import { api, formatVnd, type CategoryDetail, type PayMethod } from '../lib/api'

export function ProductPage() {
  const { slug = '' } = useParams()
  const { user, refresh } = useAuth()
  const nav = useNavigate()
  const [cat, setCat] = useState<CategoryDetail | null>(null)
  const [qty, setQty] = useState(1)
  const [coupon, setCoupon] = useState('')
  const [payMethod, setPayMethod] = useState<PayMethod>('bank')
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    api
      .category(decodeURIComponent(slug))
      .then((r) => setCat(r.category))
      .catch((e) => setErr(e.message))
  }, [slug])

  async function onOrder(e: FormEvent) {
    e.preventDefault()
    if (!user) {
      nav('/login', { state: { from: `/san-pham/${slug}` } })
      return
    }
    if (!cat) return
    setBusy(true)
    setErr('')
    try {
      const res = await api.createKeyOrder({
        category_id: cat.id,
        quantity: qty,
        coupon: coupon || undefined,
        pay_method: payMethod,
      })
      if (payMethod === 'bank') {
        nav(`/checkout/${res.order.id}`)
      } else {
        await refresh()
        nav(`/account/don/${res.order.id}`)
      }
    } catch (ex) {
      setErr(ex instanceof Error ? ex.message : 'Lỗi đặt hàng')
    } finally {
      setBusy(false)
    }
  }

  if (err && !cat) return <p className="note">{err}</p>
  if (!cat) return <p className="muted">Đang tải…</p>

  const desc = [cat.short_desc, cat.description].find((h) => h && h.replace(/<[^>]*>|&nbsp;|[\s.]/g, ''))

  return (
    <div className="prod">
      <Link className="okey-back" to="/mua-minecraft">
        <i className="fa-solid fa-arrow-left" aria-hidden /> Key Minecraft
      </Link>
      <h1 className="page-title">{cat.name}</h1>
      <div className={`prod-layout${desc ? '' : ' prod-layout-single'}`}>
        {desc ? <div className="panel prose prod-desc" dangerouslySetInnerHTML={{ __html: desc }} /> : null}
        <div className="panel prod-order">
          <p className="price">
            {formatVnd(cat.price_transfer)}{' '}
            <small>
              <s>{formatVnd(cat.price)}</s>
            </small>
          </p>
          <div className="meta-row">
            <span className="chip">{cat.deliver === 'instant' ? 'Giao tự động' : 'Giao thủ công'}</span>
            {cat.stock != null ? <span className="chip warn">Kho {cat.stock}</span> : null}
          </div>
          <form onSubmit={onOrder} className="form-stack">
            <label>
              Số lượng
              <input
                type="number"
                min={1}
                value={qty}
                onChange={(e) => setQty(Math.max(1, Number(e.target.value) || 1))}
              />
            </label>
            <label>
              Mã giảm giá
              <input value={coupon} onChange={(e) => setCoupon(e.target.value)} placeholder="Tuỳ chọn" />
            </label>
            <PayMethodPicker
              value={payMethod}
              onChange={setPayMethod}
              priceTransfer={cat.price_transfer}
              priceXu={cat.price}
              qty={qty}
            />
            {err ? <p className="note">{err}</p> : null}
            <button className="btn btn-primary" type="submit" disabled={busy}>
              {busy
                ? 'Đang tạo…'
                : `Mua ngay — ${formatVnd(payTotal(payMethod, cat.price_transfer, cat.price, qty))}`}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}
